module.exports = __webpack_public_path__ + "6bb1f1bd2e0df838b93f3c6692d3c45d.svg";